import React from "react"

function DebouncedInput<T>({
  value: initialValue,
  onChange,
  debounce = 300,
  ...props
}: {
  value: T
  onChange: (value: T) => void
  debounce?: number
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) {
  const [value, setValue] = React.useState(initialValue)

  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value, onChange, debounce])

  return <input {...props} value={value} onChange={(e) => setValue(e.target.value as any)} />
}

export { DebouncedInput }
